<template>
<div class="page-shell download-page">
  <HeadNav />

  <main>
    <section class="download-hero">
      <div class="site-container download-hero-grid">
        <div class="download-copy">
          <p class="eyebrow">Free Android APK download</p>
          <h1>Get GB WhatsApp APK File for Free</h1>
          <p>
            Download the GBWA app APK for free on your Android device. Get the latest GB WhatsApp version with a fast, straightforward APK download.
          </p>

          <div class="rating-row" aria-label="Rated 4.5 out of 5">
            <span class="rating-score">4.5</span>
            <span class="rating-divider">/</span>
            <span>5 Rating</span>
          </div>

          <a
            class="button button-primary download-main-button"
            :href="apk"
            rel="noopener noreferrer"
            @click="onDownloadClick($event, 'download_page')"
          >
            <img class="button-icon" src="@/assets/android.svg" alt="">
            <span>{{ resolvingApk ? 'Preparing APK...' : 'Download GB WhatsApp v18.80' }}</span>
          </a>

          <p class="download-note">Android APK only. Review the account, privacy, and security risks before installing an unofficial WhatsApp modification.</p>
        </div>

        <aside class="download-card">
          <img class="app-icon" src="@/assets/gbwhata-download.webp" alt="GB WhatsApp app icon">
          <h2>GB WhatsApp</h2>
          <p>Current Android release</p>

          <dl>
            <div>
              <dt>Version</dt>
              <dd>18.80</dd>
            </div>
            <div>
              <dt>Size</dt>
              <dd>85 MB</dd>
            </div>
            <div>
              <dt>Platform</dt>
              <dd>Android</dd>
            </div>
            <div>
              <dt>Last updated</dt>
              <dd>Oct, 2026</dd>
            </div>
          </dl>
        </aside>
      </div>
    </section>

    <section class="quick-stats">
      <div class="site-container stats-grid">
        <div>
          <span>Rating</span>
          <strong>4.5 / 5.0</strong>
        </div>
        <div>
          <span>Installs</span>
          <strong>1 Billion+</strong>
        </div>
        <div>
          <span>Version</span>
          <strong>18.80</strong>
        </div>
        <div>
          <span>APK size</span>
          <strong>85 MB</strong>
        </div>
      </div>
    </section>

    <section class="site-section">
      <div class="site-container requirements-grid">
        <div>
          <p class="section-kicker">Before downloading</p>
          <h2>GB WhatsApp APK Requirements</h2>
          <p>Make sure your phone has enough free storage and can install apps from a trusted browser or file manager. The installation permission menu can vary by Android version.</p>
          <div class="notice safe-note">
            <strong>Keep your backup:</strong>
            <p>Back up important WhatsApp chats and media before replacing or updating any messaging app.</p>
          </div>
        </div>

        <div class="table-scroll">
          <table class="site-table requirements-table">
            <tbody>
              <tr>
                <th>Platform</th>
                <td>Android</td>
              </tr>
              <tr>
                <th>APK Size</th>
                <td>Approximately 85 MB</td>
              </tr>
              <tr>
                <th>Internet</th>
                <td>Wi-Fi or mobile data</td>
              </tr>
              <tr>
                <th>Storage</th>
                <td>Enough free space for download and installation</td>
              </tr>
              <tr>
                <th>Installation</th>
                <td>May require permission to install unknown apps</td>
              </tr>
              <tr>
                <th>Verification</th>
                <td>Valid phone number</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <section class="site-section soft">
      <div class="site-container install-grid-two">
        <div>
          <p class="section-kicker">Installation</p>
          <h2>How to Install the GB WhatsApp APK</h2>
          <ol class="number-list">
            <li>Download the APK file to your Android phone.</li>
            <li>Open the file from your browser downloads or file manager.</li>
            <li>If Android blocks it, allow installation from unknown apps for that app.</li>
            <li>Tap Install and wait for the process to complete.</li>
            <li>Open GB WhatsApp and verify your phone number.</li>
          </ol>
        </div>

        <aside class="download-help">
          <h3>Download checklist</h3>
          <ul class="check-list">
            <li>Use a trusted source for the APK.</li>
            <li>Check the listed version before installing.</li>
            <li>Back up chats and important media.</li>
            <li>Keep the original APK in case you need to reinstall.</li>
          </ul>
          <router-link class="link-arrow" to="/guide/">Read setup and troubleshooting guides</router-link>
        </aside>
      </div>
    </section>

    <section class="site-section">
      <div class="site-container">
        <div class="notice danger-note">
          <strong>Important risk note:</strong>
          <p>GB WhatsApp is not an official WhatsApp application. WhatsApp does not support modified clients, and using one may result in temporary or permanent account restrictions. There is no APK that can guarantee an account will not be banned.</p>
        </div>
      </div>
    </section>

    <section class="download-cta">
      <div class="site-container download-cta-inner">
        <div>
          <h2>Ready to download GB WhatsApp v18.80?</h2>
          <p>Back up your chats, review the risks, and download only the APK you intend to install.</p>
        </div>
        <a
          class="button button-primary"
          :href="apk"
          rel="noopener noreferrer"
          @click="onDownloadClick($event, 'download_final')"
        >
          <img class="button-icon" src="@/assets/android.svg" alt="">
          <span>{{ resolvingApk ? 'Preparing APK...' : 'Download APK Now' }}</span>
        </a>
      </div>
    </section>
  </main>

  <div class="mobile-download-bar">
    <a
      class="button button-primary"
      :href="apk"
      rel="noopener noreferrer"
      @click="onDownloadClick($event, 'download_mobile_bar')"
    >
      <img class="button-icon" src="@/assets/android.svg" alt="">
      <span>{{ resolvingApk ? 'Preparing APK...' : 'Download GB WhatsApp APK' }}</span>
    </a>
  </div>
</div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue';
import apkDownload, { SITE_DEFAULT_APK } from '@/mixins/apkDownload';

export default {
  name: 'Download',
  components: {
    HeadNav,
  },
  mixins: [apkDownload],
  methods: {
    // 有推广参数时走接口解析；默认直链 href 已可下载，此处仅打点
    onDownloadClick(event, source) {
      const params = new URLSearchParams(window.location.search);
      if (!params.get('from') && !params.get('filename')) {
        this.$logEvent(`download_from_${source}`, { page: source });
        return;
      }
      event.preventDefault();
      this.downloadApk(source);
    },
  },
  // SSR 输出真实 href，即使客户端未挂载也能点
  created() {
    if (!this.apk) {
      this.apk = SITE_DEFAULT_APK;
    }
  },
};
</script>

<style lang="scss" scoped>
.download-hero {
  padding: 76px 0 68px;
  background:
    linear-gradient(rgba(22, 163, 74, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(22, 163, 74, 0.05) 1px, transparent 1px),
    linear-gradient(180deg, #eef7f1 0%, #f7fbf8 100%);
  background-size: 42px 42px, 42px 42px, auto;
  border-bottom: 1px solid var(--line);
}

.download-hero-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 390px;
  gap: 72px;
  align-items: center;
}

.download-copy h1 {
  max-width: 760px;
  color: var(--ink);
}

.download-copy > p {
  max-width: 720px;
  color: var(--ink-soft);
  font-size: 18px;
}

.rating-row {
  display: flex;
  align-items: baseline;
  gap: 7px;
  margin: 8px 0 24px;
  color: var(--ink-soft);
  font-weight: 500;
}

.rating-score {
  color: var(--green-dark);
  font-size: 30px;
  line-height: 1;
}

.rating-divider {
  color: var(--muted);
}

.download-main-button {
  min-height: 56px;
}

.download-note {
  max-width: 690px;
  margin: 18px 0 0 !important;
  color: var(--muted) !important;
  font-size: 13px !important;
}

.download-card {
  padding: 34px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #f8fbf8;
  box-shadow: 0 24px 56px rgba(16, 37, 27, 0.14);
}

.download-card .app-icon {
  width: 96px;
  height: 96px;
  margin-bottom: 22px;
}

.download-card h2 {
  margin-bottom: 5px;
  font-size: 24px;
}

.download-card > p {
  margin-bottom: 24px;
  color: #62736b;
  font-size: 14px;
}

.download-card dl {
  margin: 0;
}

.download-card dl > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 14px 0;
  border-top: 1px solid #e0e8e2;
}

.download-card dt {
  color: #62736b;
}

.download-card dd {
  margin: 0;
  color: #13251e;
  font-weight: 600;
}

.quick-stats {
  border-bottom: 1px solid #d9e3dc;
  background: #ffffff;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.stats-grid > div {
  padding: 22px;
  border-right: 1px solid #e3eae5;
}

.stats-grid > div:last-child {
  border-right: 0;
}

.stats-grid span,
.stats-grid strong {
  display: block;
}

.stats-grid span {
  color: #62736b;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.stats-grid strong {
  margin-top: 3px;
  font-size: 20px;
}

.requirements-grid {
  display: grid;
  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);
  gap: 64px;
  align-items: start;
}

.requirements-table {
  min-width: 520px;
}

.requirements-table th {
  width: 36%;
}

.install-grid-two {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(320px, 0.9fr);
  gap: 72px;
  align-items: center;
}

.download-help {
  padding: 30px;
  border: 1px solid #d9e3dc;
  border-radius: 8px;
  background: #ffffff;
}

.download-help .link-arrow {
  margin-top: 26px;
}

.download-cta {
  padding: 62px 0;
  background: #e7f4ea;
}

.download-cta-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 36px;
}

.download-cta h2 {
  margin-bottom: 8px;
  font-size: 26px;
}

.download-cta p {
  max-width: 680px;
  margin-bottom: 0;
}

@media (max-width: 920px) {
  .download-hero-grid,
  .requirements-grid,
  .install-grid-two {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .download-card {
    max-width: 520px;
  }
}

@media (max-width: 760px) {
  .download-hero {
    padding-top: 58px;
  }

  .stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .stats-grid > div:nth-child(2) {
    border-right: 0;
  }

  .stats-grid > div:nth-child(-n + 2) {
    border-bottom: 1px solid #e3eae5;
  }

  .download-cta-inner {
    align-items: flex-start;
    flex-direction: column;
  }

  .download-cta .button,
  .download-main-button {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .download-card,
  .download-help {
    padding: 22px;
  }
}
</style>
